import { adminTenantId } from '@logto/schemas';
import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import useNativeSignIn from '@/hooks/use-native-sign-in';
import usePlatform from '@/hooks/use-platform';
import LogtoSignature from '@/shared/components/LogtoSignature';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import styles from './index.module.scss';
import nativeTheme from './native-theme.module.scss';

const AppLayout = () => {
  const { experienceSettings, theme } = useContext(PageContext);
  const { isMobile } = usePlatform();
  const hideLogtoBranding = experienceSettings?.hideLogtoBranding === true;
  const isEvaLayout = !useNativeSignIn();
  const useNativeEvaTheme = !isEvaLayout && experienceSettings?.tenantId !== adminTenantId;

  return (
    <div
      data-eva-native-theme={useNativeEvaTheme || undefined}
      className={classNames(
        styles.viewBox,
        isEvaLayout && styles.evaViewBox,
        useNativeEvaTheme && nativeTheme.theme
      )}
    >
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
        <main
          className={classNames(
            styles.main,
            isEvaLayout && styles.evaMain,
            layoutClassNames.mainContent
          )}
        >
          <Outlet />
          {!hideLogtoBranding && !isEvaLayout && !useNativeEvaTheme && (
            <LogtoSignature
              className={classNames(styles.signature, layoutClassNames.signature)}
              theme={theme}
            />
          )}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
